module.exports = __webpack_public_path__ + "img/ELEICOES.b68da9d4.png";